/* eslint-disable @typescript-eslint/naming-convention */
import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_REQUEST_PROVIDER_LOGGING_CONFIG = createFcmDetails(
	'corgi_request_provider_logging_config',
	{
		owner: 'Site Platform',
		context: 'middle-end (RequestProvider)',
		import: false,
		description: `
		Used to configure the logging levels of requestProvider and serviceRequestProvider

		Log levels:
		- status: logging levels for response status codes
		- error: logging levels for errors (ETIMEDOUT, ECONNREFUSED, etc.)
		- retry: logging level for retries without success
		- cache: logging level for cache usage (e.g. cache hits)

		Valid values for each level are: 'off', 'info', 'warn', 'error'

		⚠️ Only global group is supported.
		`,
		template: {
			logLevel: {
				status: {
					default: 'off',
					groups: {
						'1xx': { default: 'off', codes: {} },
						'2xx': { default: 'off', codes: {} },
						'3xx': { default: 'off', codes: {} },
						'4xx': { default: 'off', codes: {} },
						'5xx': { default: 'warn', codes: {} },
					},
				},
				error: {
					default: 'warn',
					codes: {},
				},
				retry: 'off',
				cache: {
					hit: 'off',
				},
			},
		},
	},
);
